/**
 * A soft light that follows the pointer across a card.
 *
 * One delegated listener per group rather than one per card: the pointer
 * position is written to --spot-x / --spot-y on whichever `.spotlight`
 * element it is over, and motion.css draws the light from those. A frame
 * costs one style write, and only on fine pointers — touch never sees it.
 *
 * Usage:
 *   const grid = ref(null)
 *   useSpotlight(grid)
 *   <div ref="grid"><article class="spotlight">…</article></div>
 */
import { useEventListener, useMediaQuery } from "@vueuse/core";

export function useSpotlight(group) {
  const finePointer = useMediaQuery("(hover: hover) and (pointer: fine)");
  let frame = null;

  useEventListener(
    group,
    "pointermove",
    (event) => {
      if (!finePointer.value || frame) return;
      const card = event.target.closest?.(".spotlight");
      if (!card) return;

      frame = requestAnimationFrame(() => {
        frame = null;
        const rect = card.getBoundingClientRect();
        card.style.setProperty("--spot-x", `${event.clientX - rect.left}px`);
        card.style.setProperty("--spot-y", `${event.clientY - rect.top}px`);
      });
    },
    { passive: true }
  );
}
